import React from 'react'
import { InstrumentTypes } from '@node-space/types'
import { ContactInstrument } from 'types/contacts'
import { CryptoAddressSidePanelBody } from './CryptoInstrument/CryptoAddressSidePanelBody'
import { BankAccountSidePanelBody } from './FiatInstrument/BankAccountSidePanelBody'

export interface ContactInstrumentsSidePanelBodyProps {
  contactInstrument: ContactInstrument
}

export const ContactInstrumentsSidePanelBody = ({
  contactInstrument,
}: ContactInstrumentsSidePanelBodyProps) => {
  switch (contactInstrument?.type) {
    case InstrumentTypes.CRYPTO:
      return <CryptoAddressSidePanelBody contactInstrument={contactInstrument} />
    case InstrumentTypes.BANK_ACCOUNT:
      return <BankAccountSidePanelBody instrumentId={contactInstrument?.id} />
    default:
      return null
  }
}
